<template>
    <div class="screen-report">
        <TitleCommon :title="$route.meta.isFinal ? 'report final' : 'report'" :isShowButtonBack="true" />
        <div class="screen-report__container">
            <HeaderReport :dateTo="dateTo" :dateFrom="dateFrom" :isFinal="$route.meta.isFinal" />
            <LoadingScreen v-if="isLoadingScreen" />
            <template v-else>
                <div class="report__table">
                    <ContentReport
                        :displays="displays"
                        :dataSummary="dataSummary"
                        :cashier="cashier"
                        :dateTo="dateTo"
                        :dateFrom="dateFrom"
                        :dataReport="dataReport"
                        :isFinal="$route.meta.isFinal"
                        :valueDate="valueDate"
                    />
                    <FooterReport
                        :displays="displays"
                        :dataSummary="dataSummary"
                        :dataReport="dataReport"
                        :cashier="cashier"
                        :valueDate="valueDate"
                        :isFinal="$route.meta.isFinal"
                        :dateFrom="dateFrom"
                        :dateTo="dateTo"
                    />
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import ReportService from '@/services/report/report.service';

import LoadingScreen from '@/components/common/loading/loading.vue';
import TitleCommon from '@/components/common/title/index.vue';

import EventBus from '@/utils/EventBus';
import languageMixins from '@/mixins/language-mixins';

import HeaderReport from '@/components/report/header/header.vue';
import ContentReport from '@/components/report/content/content.vue';
import FooterReport from '@/components/report/footer/footer.vue';

import { formatDateUTC } from '@/utils/utils';

export default {
    mixins: [languageMixins],
    components: { LoadingScreen, HeaderReport, ContentReport, FooterReport, TitleCommon },
    data() {
        return {
            // dataSource: null,
            displays: [],
            dataSummary: null,
            cashier: null,
            dataReport: [],
            isLoadingScreen: true,
            dateFrom: new Date(),
            dateTo: new Date(),
            valueDate: '',
        };
    },
    watch: {
        $route(to, from) {
            const isReportFinal = to.path === '/report-final' ? true : false;
            this.fetchData(isReportFinal);
        },
    },
    created() {
        const isReportFinal = this.$route.path === '/report-final' ? true : false;
        this.fetchData(isReportFinal);



        EventBus.on('on-select-datepicker', this.datePickerHandler);
    },
    unmounted() {
        EventBus.off('on-select-datepicker', this.datePickerHandler);
    },
    methods: {
        datePickerHandler(param) {
            this.onChangeDatePicker(param);
        },

        onChangeDatePicker(param) {
            if (param.key === 'from') this.dateFrom = param.date;
            else this.dateTo = param.date;

            this.fetchData();
        },

        async fetchData(isReportFinal = false) {
            try {
                this.isLoadingScreen = true;
                let dateFrom = isReportFinal ? this.renderDate(new Date()) : this.renderDate(this.dateFrom);
                let dateTo = isReportFinal ? this.renderDate(new Date()) : this.renderDate(this.dateTo);
                let userInfo = this.$store.state.userInfo;
                const param = {
                    from: dateFrom,
                    to: dateTo,
                };

                const res = await ReportService.report(param);
                if (res.code === 200) {
                    // let param = {
                    //     currency: '',
                    //     cash_deposits: 0,
                    //     daily_profit: 0,
                    //     float_adjustments: 0,
                    //     cash_difference: 0,
                    //     true_balance: res.data.true_balance,
                    //     refunded_cancelations: 0,
                    //     payouts: 0,
                    // };

                    // res.data.reports.map((r) => {
                    //     param.currency = r.currency;
                    //     param.cash_deposits += parseFloat(r.cash_deposits);
                    //     param.daily_profit += parseFloat(r.daily_profit);
                    //     param.float_adjustments += parseFloat(r.float_adjustments);
                    //     param.cash_difference += parseFloat(r.cash_difference);
                    //     param.refunded_cancelations += parseFloat(r.refunded_cancelations || 0);
                    //     param.payouts += parseFloat(r.payouts);

                    //     r['product_type'] = this.getTranslatedText(r.product_type);
                    // });
                    let valueDate =
                        dateFrom == dateTo ? this.renderDate(dateTo, true) : `${this.renderDate(dateFrom, true)} - ${this.renderDate(dateTo, true)}`;
                    let cashier = userInfo?.details;
                    cashier['locked'] = res.data.cashier_locked_status;
                    cashier['title'] = 'Report of';
                    this.valueDate = valueDate;
                    // this.dataSource = param;
                    this.cashier = cashier;
                    this.dataReport = res.data.reports;
                    this.displays = res.data.displays || [];
                    this.dataSummary = res.data || {};
                    EventBus.emit('change-is-loading-report');
                } else {
                    let valueDate =
                        dateFrom == dateTo ? this.renderDate(dateTo, true) : `${this.renderDate(dateFrom, true)} - ${this.renderDate(dateTo, true)}`;
                    // this.dataSource = null;
                    this.dataSummary = {};
                    this.dataReport = [];
                    this.valueDate = valueDate;

                    EventBus.emit('change-is-loading-report', true);
                    const param = {
                        text: res.message || '',
                        type: 'error',
                    };
                    EventBus.emit('show-notications', param);
                }
                this.dateFrom = dateFrom;
                this.dateTo = dateTo;
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoadingScreen = false;
            }
        },

        renderDate(date, isRenderValue = false) {
            const dateFormat = formatDateUTC(date, 2);

            let valueDate = isRenderValue
                ? `${dateFormat.day}/${dateFormat.month}/${dateFormat.year}`
                : `${dateFormat.year}-${dateFormat.month}-${dateFormat.day}`;

            return valueDate;
        },

        async handleShowReport(param) {
            this.isLoadingScreen = true;
            await this.fetchData(param.isFinal);
            this.isLoadingScreen = false;
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/report.scss';
</style>
